import { Media } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

const IMG = "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=640&q=80";

export function MediaDemo() {
  return (
    <Section
      id="media"
      title="Media"
      description="One image, video, or audio clip with an optional caption. Renderer for the K2 `media` block - props are the streamed `{ kind, src, alt?, caption?, poster?, width?, height? }`."
    >
      <VariantBlock label="Image">
        <div className="w-72">
          <Media kind="image" src={IMG} alt="A laptop on a desk" caption="Fig 1. A workspace." width={640} height={427} />
        </div>
      </VariantBlock>

      <VariantBlock label="Video" caption="native controls, preload=metadata">
        <div className="w-96">
          <Media
            kind="video"
            src="https://www.w3schools.com/html/mov_bbb.mp4"
            alt="Sample video"
            caption="A short sample clip."
          />
        </div>
      </VariantBlock>

      <VariantBlock label="Audio">
        <div className="w-96">
          <Media
            kind="audio"
            src="https://www.w3schools.com/html/horse.mp3"
            alt="Sample audio"
            caption="A short sample audio clip."
          />
        </div>
      </VariantBlock>

      <VariantBlock label="Broken source (graceful error chrome)">
        <div className="w-72">
          <Media kind="image" src="https://invalid.invalid/missing.png" alt="Missing" caption="Falls back to the Image primitive's error state." width={640} height={427} />
        </div>
      </VariantBlock>
    </Section>
  );
}
